import React from "react"
import clsx from "clsx"
import { graphql, useStaticQuery } from "gatsby"
import PostColumn from "./PostColumn"
import { MenuLink } from "../menu/MenuLink"

import CategoryPill from "../header/CategoryPill"

import {
  FaPhoneSquareAlt,
  FaCopyright,
  FaPenSquare,
  FaLock,
  FaExternalLinkSquareAlt,
} from "react-icons/fa"

export const footerMenuItems = [
  {
    label: "Contact",
    url: "/contact",
    icon: FaPhoneSquareAlt,
  },
  {
    label: "Guest writing",
    url: "/write-for-us",
    icon: FaPenSquare,
  },
  {
    label: "Copyright",
    url: "/copyright",
    icon: FaCopyright,
  },
  {
    label: "Privacy",
    url: "/privacy",
    icon: FaLock,
  },
  {
    label: "Dunebook",
    url: "https://dunebook.com",
    target: "_blank",
    icon: FaExternalLinkSquareAlt,
  },
  {
    label: "Learn React and React Native",
    url: "https://akashmittal.com",
    target: "_blank",
    icon: FaExternalLinkSquareAlt,
  },
]

export const Footer = ({ ...props }) => {
  const data = useStaticQuery(footerQuery)

  return (
    <footer
      className={clsx(
        "pt-12 pb-8",
        "bg-gradient-to-r from-primary to-secondary",
        "text-white"
      )}
      {...props}
    >
      {/* Upper Footer */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 mx-6 lg:mx-12 gap-16 mb-16">
        <PostColumn title="Dev Tips" posts={data.devTips.nodes} />
        <PostColumn title="Code Examples" posts={data.codeExamples.nodes} />
        <PostColumn title="Errors Solved" posts={data.errorsSolved.nodes} />
      </div>
      {/* Lower Footer */}
      <div className="grid lg:grid-cols-2 mx-6 lg:mx-12 gap-16">
        <div className="flex flex-col">
          {footerMenuItems.map((item, index, arr) => {
            const Icon = item.icon
            return (
              <div
                key={item.label + index}
                className={clsx(
                  "py-4",
                  "flex item-center space-x-2",
                  index + 1 < arr.length && "border-b border-gray-500"
                )}
              >
                {item.icon && (
                  <div className="pt-1">
                    {" "}
                    <Icon />
                  </div>
                )}
                <MenuLink menuItem={item} className={clsx("hover:underline")} />
              </div>
            )
          })}
        </div>
        <div className="flex flex-row space-x-2 flex-wrap items-start self-start mb-12">
          {data.categories.nodes.map((item) => (
            <CategoryPill
              key={item.id}
              {...item}
              className="mb-3 bg-[#E84D8950]"
            />
          ))}
        </div>
      </div>
      <div>
        <p className="text-base text-center">
          &copy; {new Date().getFullYear()} Codesource.io
        </p>
      </div>

     

<script dangerouslySetInnerHTML={{ __html: `(function(){
    if(typeof _bsa !== 'undefined' && _bsa) {
      _bsa.init('hovercard', 'stickybox', 'CE7IT53M', 'CESIKKJ7', 'placement:codesourceio', { target: "#hovercard_codesourceio" });
    }
  })();"` }} />

  
    </footer>
  )
}

const footerQuery = graphql`
  query {
    devTips: allWpPost(
      limit: 5
      sort: { order: DESC, fields: date }
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: "Dev Tips" } } } }
      }
    ) {
      nodes {
        ...FooterPostFragment
      }
    }
    codeExamples: allWpPost(
      limit: 5
      sort: { order: DESC, fields: date }
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: "Code examples" } } } }
      }
    ) {
      nodes {
        ...FooterPostFragment
      }
    }
    errorsSolved: allWpPost(
      limit: 5
      sort: { order: DESC, fields: date }
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: "Errors solved" } } } }
      }
    ) {
      nodes {
        ...FooterPostFragment
      }
    }
    categories: allWpCategory {
      nodes {
        id
        uri
        name
      }
    }
  }

  fragment FooterPostFragment on WpPost {
    id
    title
    date(formatString: "LL")
    uri
    featuredImage {
      node {
        link
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
